module.exports = __webpack_public_path__ + "static/media/2_5ahn.aa500ab9.png";